export default __webpack_public_path__ + "3655df247b20d7c93b5f4c781d27a71d.svg";